<template>
  <DSPopover
    v-model="modelValue"
    :placement="props.placement"
    :offset="props.offset"
    :inherit-activator-width="props.inheritActivatorWidth"
    @escape="emit('escape')"
  >
    <template #activator="{ setRef }">
      <slot
        name="activator"
        :set-ref="setRef"
        :open="open"
        :close="close"
        :toggle="toggle"
        :is-open="modelValue"
      />
    </template>

    <template #content>
      <div
        v-bind="$attrs"
        :class="DS_PICKER_CLASSES.Root"
      >
        <div
          :class="[DS_PICKER_CLASSES.Content, props.contentClass]"
          :data-cy="props.contentDataCy"
        >
          <slot name="content">
            <slot />
          </slot>
        </div>

        <div
          v-if="$slots.footer"
          :class="DS_PICKER_CLASSES.Footer"
        >
          <slot name="footer" />
        </div>
      </div>
    </template>
  </DSPopover>
</template>

<script setup lang="ts">
import DSPopover from "@/src/design_system/primitives/popover/components/DSPopover.vue";
import { DS_PICKER_CLASSES } from "@/src/design_system/shared_modules/picker/constants/classes";
import type { DSPickerEmits } from "@/src/design_system/shared_modules/picker/types/emits";
import type { DSPickerProps } from "@/src/design_system/shared_modules/picker/types/props";
import type { DSPickerSlots } from "@/src/design_system/shared_modules/picker/types/slots";

defineOptions({ inheritAttrs: false });

const props = defineProps<DSPickerProps>();
const emit = defineEmits<DSPickerEmits>();
const modelValue = defineModel<boolean>({ default: false });

defineSlots<DSPickerSlots>();

const open = (): void => {
  modelValue.value = true;
};

const close = (): void => {
  modelValue.value = false;
};

const toggle = (): void => {
  modelValue.value = !modelValue.value;
};

defineExpose({ open, close, toggle });
</script>
